import { Button } from '@client/components/_ui/data-entry/ButtonModern';
import { useOrgId } from '@client/hooks/business/org/useOrgId';
import { useLocation } from '@tanstack/react-router';
import { Result } from 'antd';

export function NotFound() {
    const orgId = useOrgId();
    const { pathname } = useLocation();

    return (
        <div className="fixed inset-0 z-20 grid place-items-center bg-muted">
            <Result
                status="404"
                title="404"
                subTitle="Sorry, the page you visited does not exist."
                extra={
                    pathname.startsWith('/console') ? (
                        <Button.Link to="/console/$orgId" params={{ orgId }} variant="secondary">
                            Back to home
                        </Button.Link>
                    ) : pathname.startsWith('/admin-console') ? (
                        <Button.Link to="/admin-console" variant="secondary">
                            Back to home
                        </Button.Link>
                    ) : (
                        <Button.Link to="/" variant="secondary">
                            Back to home
                        </Button.Link>
                    )
                }
                className="mx-auto w-full max-w-lg rounded-lg bg-card p-8 shadow-xs"
            />
        </div>
    );
}
